<template>
	<!-- 书单详情 -->
	<div class="bookinfoBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backBook">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile" v-if="height_scroll > 60">{{books_list_detail.name}}</p>
					<div>
						<div class="header_qk" 
							 @click="edit_books(books_list_detail.id)" 
							v-if="books_list_detail.user_id == userId"
						>
							<img src="../../assets/img/edit.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</van-sticky>
		<div class="bookTxt" v-if="collect_id ? true : false">
			<h4 class="bookName" ref='bookNameTxt' :style="booksListDetailStyle">{{books_list_detail.name}}</h4>
			<div class="auther_box">
				<div class="autherImg">
					<img v-if="books_list_detail.avatar!=undefined?true:false" :src="$api.$BASE_URL_img+books_list_detail.avatar" alt="" />
					<span>{{books_list_detail.maker}}</span>
				</div>
				<p class="booktext" v-html="books_list_detail.describe">
					
				</p>
			</div>
		</div>
		<!-- 列表 -->
		<div class="bookListTxtBox">
			<div class="bookListTxt" v-for="(item,index) in books_list_detail.book_list" :key='item.id'
			@touchstart.stop="gotouchstart(item.id)"
				 @touchmove.stop="gotouchmove" @touchend.stop="gotouchend(item.id)"
			>
				<div class="bookBox">
					<div class="bookImg" @click="readFn(item.id,books_list_detail.id)">
						<img :src="$api.$BASE_URL_img+item.cover_image" alt="" />
					</div>
					<div class="bookInfo_relative">
						<div class="bookInfo_absolute">
							<div class="bookName_updataTime">
								<div class="updataTime">
									<p class="bookName">{{item.book_name}}</p>
								</div>
								<p class="auther">{{item.author}}</p>
							</div>
							<div class="typeIntroBox">
								<p class="bookType">{{item.original_name}} - {{item.appetency_name}} - {{item.epoch_name}} - {{item.type_name}}</p>
								<div class="introduction" >
									<!-- <span></span> -->
									{{item.introduce}}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="txt" v-html="item.comment"></div>
				<!-- <div class="txt">书单书单书店回复你</div> -->

				<div class="btn_scReadbox">
					<div  class="leftbtn_scReadbox" @click="collect_one(item.id,index,item.isTrue)" v-if="item.is_collect == 1">
						<img src="../../assets/img/startsc_active.png" alt="">
						<p >已收藏</p>
					</div>
					<div v-else class="leftbtn_scReadbox" @click="collect_one(item.id,index,item.isTrue)">
						<!-- <img v-if="scBookIds == item.id" src="../../assets/img/startsc_active.png" alt=""> -->
						<!-- v-if="scBookIds != item.id" -->
						<img  src="../../assets/img/startsc.png" alt="">
						<!-- v-if="scBookIds == item.id" -->
						<!-- <p >已收藏</p> -->
						<!-- v-if="scBookIds != item.id" -->
						<p >收藏</p>
					</div>
					<!-- <div  v-show="bookSc == true" class="leftbtn_scReadbox" @click="collect_one01(item.id,index,item.isTrue)">
						<img src="../../assets/img/startsc_active.png" alt="">
						<p>已收藏</p>
					</div> -->
					<div class="rightbtn_scReadbox" @click="lj_readBook(item.id,item.first_chapter)">
						<img src="../../assets/img/read.png" alt="">
						<p>阅读</p>
					</div>
				</div>
			</div>
		</div>

		<!-- 定位 tab -->
		<!-- 底部 -->
		<div class="footer">
			<button v-for="(itemBtn,index) in btnlist" :key="itemBtn.id" 
			 @click="tabbtn(itemBtn.id)"><span v-if="index == 1" class="active">{{itemBtn.name}}</span>
			<span v-if="index !=1">{{itemBtn.name}}</span> 
			</button>
		</div>
		<!-- 弹出框 -->
		<!-- 弹窗 -->
		<div class="tostBoxFather" v-show="tostShowBox">
			<div class="header_img">
				<img src="../../assets/img/pltost.png" alt="" />
			</div>
			<!-- <div class="dog_img">
				<img src="../../assets/img/dog.png" alt="" />
			</div> -->
			<div class="tostBoxson">
				<div class="yunjinbiBox">
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''" v-for="(item, index) in yunjinbiList" :key="index"
					 @click="itemyunjinbiFn(index,item.txt,item.num)">
						<div class="yunjinbi_left">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="yunjinbi_right">
							<span>{{item.txt}}</span></br>
							<span v-if='item.num ==0'>{{item.jinbi}}</span>
							<span v-if='item.jinbi ==null'>{{item.num}}</span>
						</div>
					</div>
				</div>
				<div class="selecttost">
					<div>
						<span class="userInfoUsername"><input type="text" v-model="userInfoUsername"></span>
						<span class="autherName">{{userInfo.username}}</span> 
						<span @click="toggle" class="seleValue">
							<i v-model="queryTitle">{{queryTitle}}</i>
							<img src="../../assets/img/downarr.png" alt="">
						</span>
					</div>
					<ul v-show="selectItem" class="select_item">
						<li v-for="(item,index) in selectItemList" @click="query_select(item.id,item.txt)" :class="queryIndex == item.id ? 'activeQuery' : ''">
							<span>{{item.txt}}</span>
							<span class="queryArr" v-if="queryIndex == item.id ? true : false"><img src="../../assets/img/query.png" alt=""></span>
						</li>
					</ul>
				</div>
				<div class="tost_say">
					<textarea ref="getValue" placeholder="说点啥..." v-model="ds_value"></textarea>
					<!-- <img src="../../assets/img/smile.png" alt="" class="smileImg" /> -->
				</div>
				<div class="submitBox">
					<img src="../../assets/img/flower.png" alt="" class="flower">
					<button @click="jumpUrl">提交</button>
				</div>
			</div>
		</div>
		<div class="mask" @click="onMask" v-show="tostShowBox"></div>
		
		<!-- deleShow -->
		<div class="luntantost" v-show="deleShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div  @click="delBooks"  class="active">
					<span>删除</span>
					</div>
			</div>
		</div>
		<div class='mask' v-show="deleShow" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {Toast,Dialog} from 'vant'
	export default {
		data() {
			return {
				collect_id: 0,
				show: false,
				btnlist: [{
						name: '评论',
						id: 1
					},
					{
						name: '收藏书单',
						id: 2
					},
					{
						name: '送礼物',
						id: 3
					},
				],
				tabbarBtnId: 3,
				books_list_detail: {},
				
				queryIndex: 2, //排序选择
				queryTitle: '2分',
				selectItem: false,
				itemShow: false,
				tostShowBox: false, //弹框
				showReply: false, //回复框
				itemyunjinbi: null, //弹框 云锦币
				selectItemList: [{
						id: -2,
						txt: '-2分',
					},
					{
						id: -1,
						txt: '-1分',
					},
					{
						id: 0,
						txt: '0分',
					},
					{
						id: 1,
						txt: '1分',
					},
					{
						id: 2,
						txt: '2分',
					},
				],
				yunjinbiList: [{
						txt: '流星',
						jinbi: '100云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds01.png')
					},
					{
						txt: '卫星',
						jinbi: '500云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds02.png')
					},
					{
						txt: '行星',
						jinbi: '1000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds03.png')
					},
					{
						txt: '恒星',
						jinbi: '2000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds04.png')
					},
					{
						txt: '彗星',
						jinbi: '5000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds05.png')
					},
					{
						txt: 'M78星云',
						jinbi: '10000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds06.png')
					},
					{
						txt: '银河系',
						jinbi: '100000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds07.png')
					},
					{
						txt: '琼浆玉露',
						num: '20',
						imgUrl: require('../../assets/img/ds08.png')
					},
					{
						txt: '琼浆玉露',
						num: '60',
						imgUrl: require('../../assets/img/ds08.png')
					}
				],
				userInfo:{},
				gift: '',
				userId: 0,
				ds_value:'',
				
				bookSc: false,
				id_bookDy: '',
				scBookIds: '',
				clearHfId: '',
				deleShow: false,
				height_scroll: 0,
				
				booksListDetailStyle: '',
				userInfoUsername: '',//昵称字段
			}
		},
		created() {
			this.collect_id = this.$route.query.id || this.$route.query.index || this.$route.query.listId;
			this.get_books_list_detail();
			this.userInfo = JSON.parse(window.localStorage.getItem('userInfoData'));
			this.userId = JSON.parse(window.localStorage.getItem('userInfoData')).user_id;
			this.userInfoUsername =this.userInfoUsername != '' ? this.userInfoUsername : JSON.parse(localStorage.getItem('userInfoData')).nickname;
		},
		methods: {
			hideTost01() {
				this.deleShow = false;
			},
			// 删除书单
			delBooks() {
				var _t = this;
				Dialog.confirm({
						// title: '',
						message: '删除',
					})
					.then(() => {
							_t.$axios.post(_t.$api.del_from_list,{
								book_list_id:_t.books_list_detail.id,
								book_id: _t.clearHfId
							}).then(res => {
								if (res.data.code == 1) {
									_t.get_books_list();
									_t.isDel = false;
									_t.$emit("queryIndexbind", 0)
								}
								_t.$toast(res.data.msg);
							})
						_t.get_books_list_detail();
						_t.deleShow = false;
					})
					.catch(() => {
						// on cancel
					});
			},
			gotouchstart(id) {
				this.clearHfId = id;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 800); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend(id) {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
					
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			itemyunjinbiFn(data, txt, num) {
				this.itemyunjinbi = data;
				if(this.itemyunjinbi == 0){
					this.ds_value ="黑夜给了我黑色的眼睛，我却用来寻找流星~"
				}else if(this.itemyunjinbi == 1){
					this.ds_value ="百年树人，十年树木，五年造卫星~"
				}else if(this.itemyunjinbi == 2){
					this.ds_value ="千里之行，始于足下；万里星空，有辣么一颗小行星~"
				}else if(this.itemyunjinbi == 3){
					this.ds_value ="苟有恒，不必三更起五更眠又有黑眼圈~"
				}else if(this.itemyunjinbi == 4){
					this.ds_value ="盛年不重来，彗星难在寻"
				}else if(this.itemyunjinbi == 5){
					this.ds_value ="逝者如斯夫，不舍星云"
				}else if(this.itemyunjinbi == 6){
					this.ds_value ="不积跬步，无以至千里；不积小流，无以成银河~"
				}else if(this.itemyunjinbi == 7){
					this.ds_value ='人间精品快乐汽水，九霄瑶池琼浆玉露'
				}
				if (txt == '琼浆玉露') {
					this.coin = ''
				} else {
					this.coin = txt
				}
			
				this.gift = num
			},
			query_select(index, txt) {
				console.log(index)
				this.c_score = txt
				this.queryIndex = index
				this.queryTitle = txt
				this.selectItem = !this.selectItem
			},
			onMask() {
				this.tostShowBox = !this.tostShowBox
			},
			toggle() {
				this.selectItem = !this.selectItem
			},
			// 点击提交
			jumpUrl() {
				if (this.$refs.getValue.value) {
					this.content = this.$refs.getValue.value
					this.tostShowBox = !this.tostShowBox;
					this.$axios.post(this.$api.add_comment_index,{
						list_id: this.collect_id,
						coin: this.coin,
						gift: this.gift,
						// content: this.content,
						content: this.ds_value,
						c_score: this.queryIndex,
					}).then(res =>{
						if(res.data.msg == '余额不足'){
							Toast('您的余额不足请到我的-云锦币充值进行充值后操作')
						}else {
							Toast(res.data.msg)
						}
						
					})
					this.$refs.getValue.value = ''
				} else {
					this.$toast('请输入评论内容')
				}
			
			},
			
			tabbtn(index) {
				console.log(index);
				this.tabbarBtnId = index;
				if (index == 1) {
					var that = this;
					// this指向记录
					setTimeout(function() {
						that.$router.push({
							path: '/bookPinglun',
							query: {
								list_id: that.collect_id
							}
						})
					}, 100)
				} else if (index == 3) {
					this.tostShowBox = !this.tostShowBox
				}else if(index == 2){
					this.$axios.post(this.$api.book_list_collect,{
						list_id: this.collect_id
					}).then(res =>{
						if(res.data.code == 1){
							Toast(res.data.msg);
							this.get_books_list_detail();
						}else{
							Toast(res.data.msg);
						}
					})
				}
			},
			showTk() {
				this.show = false
			},
			backBook() {
				if(this.$route.query.name == 'gxsd'){
					this.$router.go(-1);
				}else{
					this.$router.push({path: '/bookshelf',query:{com_name: 'chunai',active:1}})
				}
				
			},
			get_books_list_detail() {
				this.$axios.post(`${this.$api.books_list_detail}?collect_id=${this.collect_id}`).then(res => {
					console.log(res.data.data, 'res')
					this.books_list_detail = res.data.data;
					this.books_list_detail.book_list.forEach(item => {
						item['isTrue'] = 0;
					})
					if(res.data.code == 1){
						if(res.data.data.is_collect == 1){
							this.btnlist[1].name = '取消收藏';
						}else{
							this.btnlist[1].name = '收藏书单';
						}
					}
				})
			},
			readFn(id,ydid){
				console.log(id,ydid)
				this.$router.push({path: '/bookinfo',query:{id:id,ydid:ydid,bookdyinfo:'bookdyinfo'}})
			},
			showToast() {
				this.$toast('该功能暂未开通');
			},
			collect_one(bookIds,index,isTrue) { //单本书收藏
				this.bookSc = !this.bookSc;
				this.scBookIds = bookIds;
				this.books_list_detail.book_list[index].isTrue = 1;
				this.books_list_detail.book_list.forEach(item => {
					item.isTrue = 0;
					this.books_list_detail.book_list[index].isTrue = 1;
				})
				console.log(this.books_list_detail.book_list[index],'this.books_list_detail.book_list[index]')
				this.$axios.post(`${this.$api.xianmian_collect}?books_ids=${bookIds}`).then(res => {
					// console.log(res.data.data, 'res')
					Toast(res.data.msg);
					
					this.get_books_list_detail();
				})
				
			},
			// collect_one01(bookIds,index,isTrue) { //单本书收藏
			// 	this.bookSc = !this.bookSc;
			// 	this.books_list_detail.book_list.forEach(item => {
			// 		item.isTrue = 0;
			// 	})
			// 	console.log(this.books_list_detail.book_list[index],'this.books_list_detail.book_list[index]')
			// 	this.$axios.post(`${this.$api.xianmian_collect}?books_ids=${bookIds}`).then(res => {
			// 		// console.log(res.data.data, 'res')
			// 		Toast(res.data.msg);
			// 	})
			// },
			lj_readBook(readIds,first_chapter) { //阅读
				this.$router.push({
					path: '/readbook',
					query: {
						readId: first_chapter,
						books_id: readIds,
					}
				})
			},
			edit_books(id) { //编辑书单
				console.log(id)
				this.$router.push({
					path:'/cjsd',
					query:{
						listId: id,
						editBookLis: 'cjsdEdit'
					},
				});
			},
			handleScroll() {
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
				if(this.height_scroll > 60){
					// this.booksListDetailStyle = {
					// 	'-webkit-transform': 'translate(' + 50+ '%' + ',' + 50+ '%' +')',
					// 	transitionDuration: '5s'
					// }
				}
			},

		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>

<style lang="less" scoped>
	.bookinfoBox {
		height: calc(100vh);
		// overflow-y: scroll;
		.mask {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			overflow: hidden;
			z-index: 100;
			background-color: rgba(0, 0, 0, .4);
		}
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc03.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				justify-content: space-between;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						height: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					// flex: 1;
					text-align: center;
					font-size: 34px;
					width:70%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					/*px*/
				}

				.header_qk {
					img {
						position: absolute;
						top: 50%;
						right: 16px;
						transform: translateY(-50%);
						width: 50px;
						height: 50px;
					}
				}
			}

		}

		// 头像部分
		.bookTxt {
			background-color: #fff;
			padding: 20px 16px;
			margin-bottom: 10px;
			border-bottom: 15px solid #F0F0F0;

			.bookName {
				font-size: 30px;
				/*px*/
				font-weight: bold;
				color: #000000;
			}

			.auther_box {
				.autherImg {
					height: 80px;
					padding-top: 20px;
					padding-bottom: 10px;

					img {
						width: 60px;
						height: 60px;
						border-radius: 50%;
						vertical-align: middle;
						box-shadow: 0 0px 4px 0 rgba(0, 0, 0, .2);
						/*no*/
					}

					span {
						padding-left: 30px;
						font-size: 26px;
						/*px*/
						font-weight: 400;
						color: #000;
						opacity: 0.6;
					}
				}

				.booktext {
					// text-indent: 2em;
					line-height: 45px;
					font-size: 30px;
					/*px*/
					color: #000;
				}
			}
		}



		//列表
		.bookListTxtBox {
			background-color: #fff;
			padding: 0px 16px;
			height: calc(100vh - 150px);
			.bookListTxt {
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				background-color: #fff;
				padding: 20px 0px;
				padding-top: 20px;

				.bookBox {
					display: flex;
					padding-bottom: 16px;

					.bookImg {
						width: 180px;
						height: 270px;
						overflow: hidden;
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						img {
							height: 100%;
							width: 100%;
							vertical-align: middle;
							
						}
					}

					.bookInfo_relative {
						flex: 1;
						margin-left: 20px;
						position: relative;

						.bookInfo_absolute {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							left: 0;

							.bookName_updataTime {
								.updataTime {
									// padding-top: 10px;
									display: flex;
									justify-content: space-between;
									line-height: 40px;

									.bookName {
										font-size: 30px;
										/*px*/
										font-weight: normal;
										color: #000000;
									}
								}

								.auther {
									padding-top: 20px;
									color: #000;
									font-size: 26px;
									/*px*/
									opacity: 0.6;
								}
							}

							.typeIntroBox {
								color: #000;
								margin-top: 20px;
								font-size: 24px;/*px*/
								opacity: 0.4;
								.bookType {
									// color: #b8b8b8;
									padding-bottom: 20px;
								}

								.introduction {
									// overflow: hidden;
									// white-space: normal;
									// text-overflow: ellipsis;
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
								}
							}

							.book_button {
								margin-top: 25px;

								button {
									border: 0;
									outline: none;
									border: 1px solid #fec6d5;
									/*no*/
									border-radius: 28px;
									padding: 0 20px;
									line-height: 40px;
									background-color: #fff8fa;
									color: #fa7298;
									margin-right: 20px;
									font-size: 26px;
									/*px*/
								}

								.active {
									background-color: #fa7298;
									color: #ffffff;
								}
							}
						}


					}
				}

				.txt {
					// text-indent: 2em;
					line-height: 45px;
					font-size: 30px;
					/*px*/
					color: #000;
				}

				.btn_scReadbox {
					margin: 0px auto;
					margin-top: 25px;
					width: 40%;
					display: flex;
					text-align: center;
					color: #fa7298;
					font-size: 24px;

					.leftbtn_scReadbox {
						flex: 1;

						img {
							width: 50px;
						}
					}

					.rightbtn_scReadbox {
						flex: 1;

						img {
							width: 50px;
						}
					}
				}

				.btn_scRead {
					text-align: center;
					padding-top: 20px;

					button {
						padding: 0 30px;
						border: 1px solid #fa7298;
						/*no*/
						line-height: 60px;
						margin-right: 120px;
						background-color: #fff;
						color: #fa7298;
						border-radius: 10px;
						font-size: 26px;
						/*px*/
					}

					button:last-child {
						margin: 0;
					}
				}
			}

			.bookListTxt:last-of-type {
				border-bottom: 0;
			}

		}

		//底部
		.footer {
			width: 100vw;
			line-height: 90px;
			position: fixed;
			bottom: 0;
			right: 0px;
			display: flex;
			background-color: #fff;
			// border-top: 1px solid #f0f0f0;
			font-size: 30px;

			/*px*/
			button {
				flex: 1;
				border: 0;
				background-color: transparent;
				color: #fa7298;
				span{
					display: inline-block;
					height: 100%;
					width: 100%;
				}
				.active {
					background-color: #ff4081;
					color: #fff;
				}
			}
		}

		// 添加到书单弹窗
		.add_booksheif {
			position: fixed;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: flex-end;

			.mask {
				flex: 1;
				background-color: rgba(0, 0, 0, .6);
			}

			.inner {
				height: 470px;

				.inner_img {
					width: 100%;
					height: auto;

					img {
						width: 100%;
					}
				}

				.inner_text {
					width: 100%;
					height: 100%;
					background-color: #fff;

					//排序方式
					.solt {
						background-color: #fff;
						position: relative;
						padding: 0 16px;
						padding-top: 20px;

						div {
							line-height: 60px;

							span {
								font-size: 32px;
								/*px*/
							}

							img {
								margin-left: 10px;
								width: 20px;
							}

						}

						ul {
							position: absolute;
							top: 80px;
							left: 100px;
							background-color: #fff;
							z-index: 100;
							padding: 0 20px;

							// box-shadow: 0 0 5px 0 rgba(0,0,0,.3);/*no*/
							li {
								line-height: 50px;
								border-bottom: 1px solid #f0f0f0;

								span {
									font-size: 28px;
									/*px*/
								}

								img {
									margin-left: 10px;
									width: 20px;
									height: 20px;
								}
							}

							.select_item {
								width: 100px;
								border-radius: 20px;
							}

							.activeQuery {
								color: #ff4081;
								border-bottom: 4px solid #f0f0f0;
								/*no*/
							}
						}
					}
				}
			}

		}
		// 弹窗
		.tostBoxFather {
			z-index: 1000;
			position: fixed;
			bottom: 0;
			left: 0;
			height: 1100px;
			width: 100vw;
			overflow: hidden;
			color: #3d3d3d;
			.header_img {
				position: absolute;
				top: 4px;
				left: 0;
		
				img {
					width: 100vw;
				}
			}
		
			// .dog_img{
			// 	img {
			// 		width: 80%;
			// 		position: absolute;
			// 		top: 30%;
			// 		left: 50%;
			// 		transform: translateX(-50%);
			// 		z-index:100;
			// 	}
			// }
			.tostBoxson {
				position: absolute;
				top: 128px;
				left: 0;
				background-color: #fff;
		
				// 云锦币
				.yunjinbiBox {
					overflow: hidden;
					padding: 20px 16px;
					padding-bottom: 0;
					height: 540px;
					background: url(../../assets/img/dog.png) no-repeat center;
					background-size: 85%;
					background-position: 99% 100%;
		
					.yunjinbi {
						width: calc((100vw - 88px) / 3);
						box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .3);
						/*no*/
						border: 1px solid #fa7298;
						/*no*/
						padding: 20px 0px;
						text-align: left;
						margin-right: 20px;
						border-radius: 10px;
						float: left;
						margin-bottom: 20px;
						color: #3d3d3d;
						position: relative;
						height: 120px;
						.yunjinbi_left {
							img {
								width: 100px;
								position: absolute;
								top: 30%;
								left: 50%;
								transform: translate(-50%,-50%);
							}
						}
		
						.yunjinbi_right {
							// padding-left: 100px;
							padding-top: 55px;
							text-align: center;
						}
					}
		
					.yunjinbi.active {
						box-shadow: none;
						background-color: #fff8fa;
		
						color: #000000;
					}
		
					.yunjinbi:nth-child(3n) {
						margin-right: 0;
					}
				}
		
				.selecttost {
					background-color: #fff;
					position: relative;
					height: 80px;
					line-height: 80px;
					padding: 0 16px;
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					font-size: 30px;
		
					div {
						display: flex;
						justify-content: space-between;
						width:100%;
						.userInfoUsername {
							font-weight: 600;
							color: #ff4081;
							overflow: hidden;
							input{
								height: 76px;
								line-height: 76px;
								outline: none;
								border: 0;
								width: 200px;
							}
						}
						.autherName {
							padding-right: 40px;
							font-weight: 600;
							color: #ff4081;
						}
		
						.seleValue {
							i {
								font-style: normal;
							}
		
							img {
								padding-left: 10px;
								width: 20px;
							}
						}
					}
		
					// 下拉框css
					ul.select_item {
						position: absolute;
						top: 80px;
						right: 2%;
						background-color: #fff;
						z-index: 100;
						border-radius: 5px;
						-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
		
						/*no*/
						li {
							width: 200px;
							padding: 0 20px;
							line-height: 60px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/
		
							span {
								font-size: 28px;
								/*px*/
							}
		
							img {
								margin-left: 60px;
								width: 20px;
								height: 20px;
							}
		
							.queryArr {
								padding-left: 20px;
							}
						}
		
						.activeQuery {
							color: #ff4081;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}
					}
				}
		
				//评论
				.tost_say {
					background-color: transparent;
		
					height: 160px;
					padding: 0 16px;
					overflow: hidden;
					position: relative;
					border-bottom: 1px solid #f0f0f0;
		
					/*no*/
					.smileImg {
						position: absolute;
						bottom: 10px;
						right: 16px;
		
						img {
							width: 40px;
						}
					}
		
					textarea {
						border: 0;
						height: 190px;
						padding: 20px 0;
						width: calc(100vw - 32px);
						background-color: transparent;
					}
		
					textarea::placeholder {
						font-size: 26px;
						/*px*/
						color: #3d3d3d;
					}
				}
		
				//提交
				.submitBox {
					background-color: #fff;
					position: relative;
					text-align: center;
					margin-top: 50px;
					margin-bottom: 40px;
		
					.flower {
						position: absolute;
						top: -60px;
						left: 20%;
						width: 100px;
					}
		
					button {
						width: 90%;
						border: 0;
						border-radius: 10px;
						line-height: 80px;
						font-size: 32px;
						/*px*/
						background-color: #FF4081;
						color: #fff;
					}
				}
			}
		}

	}

	// 弹框
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 400px;
		/*px*/
		padding-bottom: 20px;
		background-color: #fff;
		border-radius: 10px;
		text-align: center;

		div>span {
			line-height: 80px;
			color: #ff4081;
		}

		span:first-child {
			font-weight: 600;
			font-size: 30px;
			/*px*/
		}

		ul>li {
			line-height: 60px;
		}
	}

	// 添加到书单弹窗
	.add_booksheif {
		position: fixed;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: flex-end;

		.mask {
			flex: 1;
			background-color: rgba(0, 0, 0, .6);
		}

		.inner {
			height: 470px;

			.inner_img {
				width: 100%;
				height: auto;

				img {
					width: 100%;
				}
			}

			.inner_text {
				width: 100%;
				height: 100%;
				background-color: #fff;

				//排序方式
				.solt {
					background-color: #fff;
					position: relative;
					padding: 0 16px;
					padding-top: 20px;

					div {
						line-height: 60px;

						span {
							font-size: 32px;
							/*px*/
						}

						img {
							margin-left: 10px;
							width: 20px;
						}

					}

					ul {
						position: absolute;
						top: 80px;
						left: 100px;
						background-color: #fff;
						z-index: 100;
						padding: 0 20px;

						// box-shadow: 0 0 5px 0 rgba(0,0,0,.3);/*no*/
						li {
							line-height: 50px;
							border-bottom: 1px solid #f0f0f0;

							span {
								font-size: 28px;
								/*px*/
							}

							img {
								margin-left: 10px;
								width: 20px;
								height: 20px;
							}
						}

						.select_item {
							width: 100px;
							border-radius: 20px;
						}

						.activeQuery {
							color: #ff4081;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}
					}
				}
			}
		}

	}

	//弹窗
	.luntantost {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		// height: 454px;
		background: url(../../assets/img/pltost.png) no-repeat;
		background-size: 100%;
		z-index: 120;
	
		img {
			position: absolute;
			bottom: 40px;
			left: 0;
			width: 100%;
		}
	
		.luntantostbgc {
			margin-top: 124px;
			z-index: 10000 !important;
			background: url(../../assets/img/dog.png) no-repeat #fff;
			background-size: 100%;
			background-position: 0px 50%;
	
			div {
				line-height: 120px;
				text-align: center;
				color: #737373;
				font-size: 30px;
				/*px*/
				z-index: 1000 !important;
			}
	
			div.active {
				color: #ff4081;
			}
	
		}
	
	}
	
	.mask {
		position: fixed;
		top: -160px;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .3);
		z-index: 100;
	}
</style>
